<template>
  <div class="modal fade" id="modal-decline-reason" tabindex="-1" role="dialog" aria-labelledby="modal-decline-reason" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          <button
            v-if="monetaryCurrency"
            type="button"
            class="btn btn-block"
            :class="reason === 'budget' ? 'btn-primary' : 'btn-dark'"
            :data-dismiss="talentCanComment ? null : 'modal'"
            @click="handleDeclineRequestReasonCallback('budget')">
            {{ $t('budget') | sentenceCase }} too low
          </button>

          <button
            type="button"
            class="btn btn-block"
            :class="reason === 'scheduling' ? 'btn-primary' : 'btn-dark'"
            :data-dismiss="talentCanComment ? null : 'modal'"
            @click="handleDeclineRequestReasonCallback('scheduling')">
            Scheduling issue
          </button>

          <button
            type="button"
            class="btn btn-block"
            :class="reason === 'information' ? 'btn-primary' : 'btn-dark'"
            :data-dismiss="talentCanComment ? null : 'modal'"
            @click="handleDeclineRequestReasonCallback('information')">
            Need more information
          </button>

          <button
            type="button"
            class="btn btn-block"
            :class="reason === 'interest' ? 'btn-primary' : 'btn-dark'"
            :data-dismiss="talentCanComment ? null : 'modal'"
            @click="handleDeclineRequestReasonCallback('interest')">
            Not interested
          </button>

          <div v-if="talentCanComment">
            <div class="decorative-divider"></div>
            <label for="scheduling_comment">Provide a comment (optional)</label>
            <textarea id="scheduling_comment" v-model="decline_comment" class="form-control" rows="2"></textarea>
            <span v-if="!$vlastMode && talentIsShortlisted">Please note that the client will see your comment</span>
            <button
              type="button"
              class="btn btn-dark margin-y-1"
              data-dismiss="modal"
              @click="handleDeclineWithCommentCallback">
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { helpers } from 'mixins/bookings'
export default {
  mixins: [helpers],
  props: {
    booking: {
      required: true
    }
  },

  data () {
    return {
      decline_comment: '',
      showCommentBox: true,
      reason: null
    }
  },

  computed: {
    talentCanComment () {
      if (this.$vlastMode) {
        return this.$declineCommentModuleEnabled
      }
      return this.$declineCommentModuleEnabled && this.booking.talent_can_comment
    },

    talentIsShortlisted () {
      return this.booking.talent && this.booking.talent[0] && this.booking.talent[0].response && this.booking.talent[0].response.shortlisted
    }
  },

  methods: {
    handleDeclineRequestReasonCallback (reason) {
      this.reason = reason
      if (!this.talentCanComment) {
        this.$emit('input', reason)
        this.reason = null
      }
    },

    handleDeclineWithCommentCallback () {
      this.$emit('comment-added', this.decline_comment)
      this.$emit('input', this.reason)
      this.decline_comment = null
      this.reason = null
    }
  }
}
</script>

<style scoped lang="scss">
.btn {
  letter-spacing: 3px;
}
</style>
